export const toScroll = (y) => {
  window.scrollTo({
    top: y,
    behavior: "smooth",
  });
};
